import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';

@Component({
  selector: 'app-social-media-monitor',
  templateUrl: './social-media-monitor.component.html',
  styleUrls: ['./social-media-monitor.component.scss']
})
export class SocialMediaMonitorComponent implements OnInit {

  config: any
  socialUrl: SafeResourceUrl
  urlString = ""

  constructor(
    private router: Router,
    private util: UtilService,
    private api: ApiService,
    private sanitizer: DomSanitizer) { }

  async ngOnInit() {
    this.util.ShowWaiting(true)

    this.config = await this.api.get("master", "configuration")
    if(this.config == null || this.config.length == 0){

    }

    let socialConfig: any = this.config.filter((c: any) => {
      return c.dpa_name.toUpperCase() == "SOCIAL"
    })

    if(socialConfig == null || socialConfig.length == 0){
      this.util.ErrorDialog("ไม่สามารถดึงค่า Config ได้ กรุณาติดต่อเจ้าหน้าที่")
    }
    else{
      this.urlString = socialConfig[0].dpa_value
      this.socialUrl = this.sanitizer.bypassSecurityTrustResourceUrl(socialConfig[0].dpa_value)
    }

    this.util.ShowWaiting(false)
  }

  newTab(){
    window.open(this.urlString, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/social-media-monitor/social-media-monitor.component.ts